var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCafe = function SvgIcCafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M1.927 3.515h11.921v5.96a5.96 5.96 0 0 1-5.96 5.961v0a5.96 5.96 0 0 1-5.961-5.96zM14.008 10.292c1.433 0 2.594-1.047 2.594-2.338 0-1.29-1.162-2.337-2.594-2.337"
  })));
};
export default SvgIcCafe;